export const ACCENT_COLORS = {
  gold: "#C8AA78",
  teal: "#8AACB8",
  rose: "#B88A8A",
  green: "#9AB88A",
};

export const orbPositions = [
  { left: "15%", top: "20%" },
  { left: "72%", top: "35%" },
  { left: "40%", top: "60%" },
  { left: "85%", top: "15%" },
  { left: "25%", top: "75%" },
  { left: "60%", top: "45%" },
  { left: "50%", top: "25%" },
  { left: "33%", top: "80%" },
];

export const orbDurations = [4, 5, 3, 5, 3, 4, 4, 3.5];

export const articles = [
  {
    title: "Design Hiring is Broken!",
    subtitle: "The curse of whiteboardings",
  },
  {
    title: "Working with Product Managers",
    subtitle: "A guide for product designers",
  },
  {
    title: "AI in Product Design",
    subtitle: "Is your job at risk?",
  },
];

export const projects = [
  {
    title: "Revamping UI for ParkEasy",
    description:
      "Finding space to park your car and managing parking lots — made effortless. Find, Book, Park, Instantly.",
    accent: ACCENT_COLORS.gold,
    tags: ["Mobile App", "UX Research", "UI Design"],
  },
  {
    title: "Simplifying Subscriptions at Cashfree",
    description:
      "Led a revamp that onboarded 40 new merchants and drove a 400% revenue increase.",
    accent: ACCENT_COLORS.teal,
    tags: ["Dashboard", "Payments", "B2B SaaS"],
  },
  {
    title: "Employee Healthcare at Nova Benefits",
    description:
      "The project led to a 40% increment in platform usage and 32% TAT reduction in employee onboarding.",
    accent: ACCENT_COLORS.rose,
    tags: ["Healthcare", "Enterprise", "Design System"],
  },
  {
    title: "Doccot — Design System Manager",
    description:
      "A comprehensive platform for managing, documenting, and scaling design systems across organizations.",
    accent: ACCENT_COLORS.green,
    tags: ["Platform", "Design Systems", "SaaS"],
  },
];

export const philosophies = [
  {
    icon: "◇",
    title: "Simplicity in Complexity",
    desc: "I break down intricate workflows into clear, actionable experiences.",
    detail: "Whether it's a 12-step onboarding or an enterprise dashboard, I start by mapping every edge case — then systematically remove everything that doesn't earn its place. The result feels obvious in hindsight, which is exactly the goal.",
  },
  {
    icon: "◎",
    title: "Design with Purpose",
    desc: "Every pixel and decision should solve a problem, without ambiguity.",
    detail: "I push back on decoration that doesn't carry meaning. Before any visual decision, I ask what job it does. That constraint forces honesty — and it's why my work tends to age well even as trends shift.",
  },
  {
    icon: "◈",
    title: "Global Thinking",
    desc: "Crafting scalable solutions that work across industries and borders.",
    detail: "Having worked across fintech, healthcare, and mobility, I've learned that the deepest design problems are universal — trust, clarity, speed. I borrow patterns across domains and stress-test assumptions against users who aren't like me.",
  },
  {
    icon: "◉",
    title: "Collaboration First",
    desc: "Great products happen when designers, engineers, and PMs work as one.",
    detail: "I embed in cross-functional teams early and stay late. I speak in constraints engineers respect and outcomes PMs can defend. The best feedback I've ever gotten came from a developer who finally felt heard.",
  },
];

export const parkEasyFeatures = [
  {
    label: "Get Started",
    sub: "Find, Book, Park, Instantly!",
    detail: "Effortlessly secure your parking spot in seconds",
    color: ACCENT_COLORS.gold,
  },
  {
    label: "Search",
    sub: "Where are you going today?",
    detail: "Search Parking...",
    color: ACCENT_COLORS.teal,
  },
  {
    label: "Frequent Visits",
    sub: "In the last 6 months",
    detail: "Richmond Circle 5.6 km · Phoenix City Centre 7.1 km",
    color: ACCENT_COLORS.rose,
  },
  {
    label: "Navigate",
    sub: "Follow the signal",
    detail: "F22 · Basement 1 — Slide to park",
    color: ACCENT_COLORS.green,
  },
];

export const socialLinks = ["LinkedIn", "Medium", "Art"];
